import { render } from "./RightCol.vue?vue&type=template&id=1e735f78&ts=true"
import script from "./RightCol.vue?vue&type=script&lang=ts"
export * from "./RightCol.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vaab/dev/js/monujo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__